import axios from 'axios';

var API_URL = process.env.VUE_APP_API_URL;


export default class DfpService {

  getEvents(searchTerm, token) {
    return axios({
      method: "POST",
      url: `${API_URL}/history`,
      data: {searchTerm: searchTerm},
      headers: {'Authorization': `Bearer ${token}`}
    })
      .catch((err) => {console.error(err)});
  }

  getImageUrl(name, token) {
    return axios({
      method: "POST",
      url: `${API_URL}/image`,
      data: {imageUid: name},
      headers: {'Authorization': `Bearer ${token}`}
    })
      .then((response) => {
        console.log(response);
        return response.data.imageUrl;
      })
      .catch((err) => {console.error(err)});
  }

}